import React from "react";
import { useState } from "react";
import FeatherIcon from "feather-icons-react";
import ProfileDropdown from "./ProfileDropdown";
import UserSideBarContent from "./UserLeftsideBar";
import logo from "../../assets/Logo/Cgear_Black.webp";

const ProfileMenus = [
  {
    label: "My Profile",
    icon: "user",
    redirectTo: "/Profile",
  },
  {
    label: "Logout",
    icon: "log-out",
    redirectTo: "/Signin",
  },
];

const UserDashboardLayout = (props) => {
  const isMobile = window.innerWidth < 768; // adjust breakpoint if needed
  const [sidebar, setSidebar] = useState(!isMobile);
  const user = JSON.parse(localStorage.getItem("user"));
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const showSidebar = () => {
    setSidebar(!sidebar);
    const contentPage = document.querySelector(".content-page");
    if (contentPage) {
      contentPage.classList.toggle("collapsed-sidebar", sidebar);
    }
  };

  return (
    <React.Fragment>
      <div>
        <div className="navbar-custom">
          <div className="container-fluid p-0 d-flex align-items-center justify-content-between">
            <div className="topnav-left d-flex align-items-center">
              <button
                className="button-menu-mobile"
                onClick={showSidebar}
                aria-label="Toggle sidebar"
              >
                <FeatherIcon icon="menu" />
              </button>
            </div>
            <div className="topnav-right d-flex align-items-center">
              <ProfileDropdown
                profilePic={logo}
                menuItems={ProfileMenus}
                username={localStorage.getItem('email') || 'User'}
              />
            </div>
          </div>
        </div>
        <div className={`left-side-menu ${sidebar ? "activeDash" : "hideSideBar"}`}>
          <UserSideBarContent/>
        </div>
      </div>
    </React.Fragment>
  );
};
export default UserDashboardLayout;
